<template>
	<section class="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
		<div class="container flex flex-col items-center justify-center px-5 mx-auto my-8">
			<div class="flex flex-col md:flex-row max-w-6xl  bg-white p-8 rounded-lg shadow-lg dark:bg-gray-800">
				<div class="md:w-1/2 p-6">
					<h2 class="mb-4 font-extrabold text-9xl text-yellow-500 dark:text-gray-400 text-center">
						<span class="sr-only">Error</span>{{ error.statusCode }}
					</h2>
					<div class="mb-10 md:mb-20 text-gray-600 font-light text-start">
						<h1 class="font-black uppercase text-3xl lg:text-4xl text-teal-500 mb-10">Oops! {{
							error.message }}
						</h1>
						<p>{{ dataMessage }} {{
							error.description }}</p>
					</div>
					<div class="mb-20 md:mb-0 flex justify-between">
						<button @click="goBack"
							class="text-lg font-light outline-none focus:outline-none transform transition-all hover:scale-110 text-yellow-500 hover:text-yellow-600">
							<i class="fa fa-arrow-left mr-2"></i>Trở về
						</button>
						<button @click="goHome"
							class="text-lg font-light outline-none focus:outline-none transform transition-all hover:scale-110 text-yellow-500 hover:text-yellow-600">
						Trang chủ<i class="fa fa-home ml-2"></i>
						</button>
					</div>
				</div>
				<div class="md:w-1/2 mt-4 md:mt-0 p-6">
					<img src="/error.jpg" alt="Error Image" class="rounded-lg">
				</div>
			</div>
		</div>
	</section>
</template>
<script setup>
const error = useError();
const dataMessage = computed(() => {
	switch (error.value.statusCode) {
		case 404:
			return 'Trang đang tìm kiếm không tồn tại. Vui lòng nhập đường dẫn hợp lệ hoặc về trang chủ'
		case 403:
			return 'Không có quyền. Vui lòng liên hệ quản trị để cấp quyền hoặc về trang chủ'
		case 503:
			return 'Xin lỗi vì sự cố. Server hiện đang tắt!'
		default:
			return 'Xin lỗi vì sự cố. Vui lòng liên hệ quản trị để thông báo lỗi. Chân thành cảm ơn'
	}
})
const router = useRouter();

function goHome() {
	router.push('/');
}

function goBack() {
	router.back();
}
</script>